import { useState } from "react";
import * as Scrivito from "scrivito";

function SearchButton({ searchResultsPage }) {
  const [searchFieldIsVisible, setSearchFieldIsVisible] = useState(false);
  const [query, setQuery] = useState("");

  if (!searchResultsPage) {
    return null;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (searchFieldIsVisible && query.trim() !== "") {
      Scrivito.navigateTo(searchResultsPage, { q: query });
    }
    setQuery("");
    setSearchFieldIsVisible((v) => !v);
  };

  return (
    <>
      {searchFieldIsVisible && (
        <form method="GET" onSubmit={(e) => handleSubmit(e)}>
          <input
            name="q"
            autoFocus
            className="search-input"
            type="text"
            onChange={(e) => setQuery(e.target.value)}
          />
        </form>
      )}
      <a
        onClick={(e) => handleSubmit(e)}
        href="/"
        title="search"
        className="d-none d-sm-inline-block"
      >
        <i
          title="search"
          className="las la-search nav-icon me-0 me-sm-3 me-lg-5"
        />
      </a>
    </>
  );
}

export default Scrivito.connect(SearchButton);
